module.exports = __webpack_public_path__ + "static/hero-7df4309bd8ea6d2fd212c8cec28276c8.webm";